<script lang="ts">
	import { twMerge } from 'tailwind-merge';

	export let image: string;
	export let category: string;
	export let title: string;
	export let text: string;
	export let titleClass: string = '';
</script>

<div class="h-full rounded-lg py-10 text-light md:bg-light md:py-14 md:text-dark">
	<div class="flex flex-col md:flex-row">
		<div class="mb-4 md:w-1/3">
			<img src={image} alt={title} class="mx-auto" />
		</div>
		<div class="md:pr-24 lg:w-2/3">
			<h6
				class="text-sm font-semibold uppercase leading-10 tracking-widest text-light md:text-dark"
			>
				{category}
			</h6>
			<h4 class={twMerge('text-4xl font-bold', titleClass)}>{title}</h4>
			<h5 class="mt-5 text-lg leading-6">
				{text}
			</h5>
		</div>
	</div>
</div>
